import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { cn } from '@sistemas/ui'
import * as React from 'react'

/**
 * Seção que abre e fecha (shadcn sobre Radix).
 *
 * É o primitivo da divulgação progressiva: o formulário mostra o que quase
 * sempre se mexe e guarda o resto a um clique, sem virar um assistente de
 * passos. O Radix cuida do `aria-expanded`, do `aria-controls` e de manter o
 * conteúdo fora da ordem de tabulação enquanto está fechado — fazer isso com
 * `{aberto && ...}` deixaria o botão sem relação anunciada com a seção.
 *
 * A animação é a mesma do accordion (200ms), a que o doc 18 §6.6 permite, mas
 * lendo `--radix-collapsible-content-height`: cada primitivo do Radix publica a
 * altura medida na sua própria variável. Ela diz de onde o conteúdo saiu, em
 * vez de a seção surgir do nada e empurrar o rodapé.
 */

export const Collapsible = CollapsiblePrimitive.Root
export const CollapsibleTrigger = CollapsiblePrimitive.Trigger

export const CollapsibleContent = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content>
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Content
    ref={ref}
    className={cn(
      'overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down',
      className,
    )}
    {...props}
  />
))
CollapsibleContent.displayName = 'CollapsibleContent'
